import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { StudentTag } from '../GroupInteractions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPeopleGroup, faXmark } from '@fortawesome/free-solid-svg-icons'
import '../../../assets/css/pages/Expeditions/StudentGroupCard.css'
import { ExpeditionContext, useExpeditionUtils } from '../Expedition_utils'

const StudentGroupCard = ({ students, groupIndex, maxAllowableStudent }) => {
	const { assignmentMessage, isDelete } = React.useContext(ExpeditionContext)
	const { handleDeleteGroup } = useExpeditionUtils()
	const handleGenerateEmptySlot = students => {
		if (students.length < 5) {
			return _.fill(new Array(5 - students.length), null)
		}
	}

	return (
		<div
			className={`StudentGroupCard ${
				assignmentMessage.detail?.hasOwnProperty(groupIndex) && 'errorBorder'
			}`}
			key={`studentGroup-${groupIndex + 1}`}>
			<div className='StudentGroupCard__groupHeader'>
				<h4>
					<span>Group {groupIndex + 1}</span>
					<span
						className={`${
							students.length < 3 || students.length > 5 ? 'error' : 'goAhead'
						}`}>
						<FontAwesomeIcon
							icon={faPeopleGroup}
							style={{ width: '16px', height: '16px', marginRight: '4px' }}
						/>
						{students.length}
					</span>
				</h4>

				{!isDelete && (
					<button
						className='StudentGroupCard__groupHeader--deleteGroup'
						onClick={() => {
							handleDeleteGroup(groupIndex)
						}}>
						<FontAwesomeIcon icon={faXmark} style={{ width: '14px', height: '14px' }} />
					</button>
				)}
			</div>

			<div className='StudentGroupCard__groupBody'>
				{students.map((student, ind) => (
					<StudentTag
						key={Object.keys(student)[0]}
						student={student}
						location={{ groupIndex: groupIndex, studentIndex: ind }}
					/>
				))}
				{students.length !== maxAllowableStudent &&
					handleGenerateEmptySlot(students).map((ele, ind) => {
						// TODO: should later be refactored as drop zones
						return (
							<div
								className={`StudentGroupCard__groupBody__emptySlot ${
									assignmentMessage.detail?.hasOwnProperty(groupIndex) &&
									'errorBorder'
								}`}
								key={`studentGroup-${groupIndex}__emptySlot-${ind + 1}`}></div>
						)
					})}
			</div>
			{/* <div className='StudentGroupCard__groupFooter'> reserved space for setting</div> */}
		</div>
	)
}

StudentGroupCard.propTypes = {
	students: PropTypes.array.isRequired,
	groupIndex: PropTypes.number.isRequired,
	maxAllowableStudent: PropTypes.number.isRequired
}

export default StudentGroupCard
